/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Dialog/theme';

export const DialogTheme = theme;
